import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Canonical public site URL (production domain) used for structured data.
export const SITE_URL = "https://baccarats.me";

export const api = axios.create({ baseURL: API });

export const CATEGORY_ORDER = [
  "Rules & Basics",
  "Odds & Math",
  "Strategy",
  "Live Dealer",
  "Bankroll",
];
